import { toConsumableArray as _toConsumableArray, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { getTvObject, tv } from '@costar-ui/cosmos';
import flexOptions from '../../common/flex-options/flex-options.esm.js';
import fontOptions from '../../common/font-options/font-options.esm.js';
import { focusRing } from '../../theme/styles/common.esm.js';

var anchorTV = getTvObject({
  extend: focusRing,
  base: [].concat(_toConsumableArray(flexOptions.base), ['disabled:no-underline', 'disabled:cursor-default', 'forced-colors:disabled:text-action-disabled', 'transition', 'rounded', 'cursor-pointer', 'hover:text-action-neutral-hover', 'active:text-action-neutral-active']),
  variants: _objectSpread2(_objectSpread2({
    variant: {
      primary: ['text-action-primary', 'decoration-primary', 'hover:decoration-primary', 'hover:text-action-primary', 'hover:underline'],
      secondary: ['text-action-base-inverse', 'decoration-base-inverse', 'hover:decoration-base-inverse', 'hover:text-action-base-inverse', 'hover:underline'],
      neutral: 'text-action-neutral',
      inherit: ''
    }
  }, fontOptions), flexOptions.variants)
});
var base = tv(anchorTV);
var anchorStyles = {
  base: base
};

export { anchorStyles, anchorTV };
//# sourceMappingURL=anchor.styles.esm.js.map
